import "./ab-blog-post.scss";

const BlogPost = ({ content, classname = "" }) => {
  // console.log("BlogPost", content);
  return (
    <div
      className={`ab-blog-post ${classname || ""}`}
      dangerouslySetInnerHTML={{ __html: content }}
    ></div>
  );
};

export default BlogPost;
